import script from "./TournamentLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentLanding.vue?vue&type=script&setup=true&lang=js"

import "./TournamentLanding.vue?vue&type=style&index=0&id=75bcb56f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75bcb56f"]])

export default __exports__